import { useRequest } from "@certn/api";
import { showToast } from "@certn/cascadia";
import {
  DangerButton,
  Divider,
  Layout,
  Text,
  Container,
  Link,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useStyles } from "./styles";
import { AppFooter } from "../../components/app-footer";
import { AppHeader } from "../../components/app-header";

export function DeclineRequest() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const clientName = searchParams.get("client_name");
  const { caseId } = useParams();
  const styles = useStyles();
  const request = useRequest();

  const navigate = useNavigate();
  const handleDeclineRequest = async () => {
    try {
      await request(`/api/internal/applicant/case/${caseId}/decline/`, {
        method: "POST",
      });
      navigate(`/request-declined?client_name=${clientName}`);
    } catch (e) {
      console.error("Error declining the invite:", e);
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    }
  };
  return (
    <Layout
      layout="auth"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
    >
      <Container>
        <div className={styles.container}>
          <div>
            <Text as="h2" style="form/page-title">
              <Trans>Decline request</Trans>
            </Text>
          </div>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                If you've decided not to proceed with the background check for{" "}
                {{ clientName }} select the “Decline request“ button below. Once
                confirmed, {{ clientName }} will be notified and the check will
                be cancelled.
              </Trans>
            </Text>
          </div>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>Please note this action cannot be undone.</Trans>
            </Text>
          </div>
          <DangerButton
            testID="decline-request-button"
            size="large"
            onPress={handleDeclineRequest}
            fullWidth
          >
            <Trans>Decline request</Trans>
          </DangerButton>
          <Divider />
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                If you do not want to decline the request,{" "}
                <Link
                  href="/"
                  textColor="text-weak"
                  testID="cancel-decline-request"
                >
                  click here
                </Link>{" "}
                to complete the background check.
              </Trans>
            </Text>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
